import request from '@/utils/request'

/**
 * 获取预警配置
 */
export function getWarningConfig() {
  return request({
    url: '/warning/config',
    method: 'get'
  })
}

/**
 * 更新预警配置
 */
export function updateWarningConfig(data) {
  return request({
    url: '/warning/config',
    method: 'post',
    data: data
  })
}
